/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { Auth } from 'app/scripts/db/Auth';
import { isOverLimit } from 'app/scripts/lib/limits';
import { limitErrorPopover } from 'app/scripts/views/lib/limitErrorPopover';

const trackingArea = 'orgMemberLimit';
export const maybeDisplayOrgMemberLimitsError = function (elem, org, member) {
  const m = (() => {
    if (
      org != null
        ? isOverLimit('orgs', 'totalMembersPerOrg', org.get('limits'))
        : undefined
    ) {
      return {
        message: 'members exceeds total per org limit',
        params: { orgName: org.get('name'), orgId: org.get('id') },
      };
    } else if (
      member != null
        ? isOverLimit('orgs', 'totalPerMember', member.get('limits'))
        : undefined
    ) {
      if (Auth.isMe(member)) {
        return { message: 'your orgs exceed total per member limit' };
      } else {
        return {
          message: 'orgs exceeds total per member limit',
          params: { memberName: member.get('name') },
        };
      }
    }
  })();

  if (m != null) {
    limitErrorPopover({
      trackingArea,
      elem,
      ...m,
    });
    return true;
  }
  return false;
};
